exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ad-group-simple-editor[data-v-5087b04c] {\n  padding: 10px;\n}", ""]);

// exports
